import { defineComponent as _defineComponent } from 'vue'
import { ButtonIconContextual } from '@warrenbrasil/nebraska-web';

interface Props {
  value: string;
  acessibleLabel?: string;
}
interface EmitEvents {
  (event: 'input', value: string): void;
  (event: 'clear'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TextBox',
  props: {
    value: null,
    acessibleLabel: null
  },
  emits: ["input", "clear"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'input', value: string): void;
  (event: 'clear'): void;
}), expose: any, slots: any, attrs: any }) {





function inputTextbox(event: Event) {
  const target = event.target as HTMLTextAreaElement;
  emit('input', target.value.replace(/\s+/g, ' ').trim());
}

return { __sfc: true,emit, inputTextbox, ButtonIconContextual }
}

})